import { Component, Host, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  group,
  state
} from '@angular/animations';
import { OnBoardComponent } from '../on-board.component';
import { OnBoardTransitionService } from 'src/app/_services/on-board-transition.service';
import { SettingService } from 'src/app/_services/admin/setting.service';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { ErrorUtil } from 'src/app/_utilities/error';
import { OnboardDataService } from 'src/app/_services/on-board-data.service';
import { ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { MixpanelService } from 'src/app/_services/mixpanel.service';
@Component({
    selector: 'app-dropdown-industry',
    templateUrl: './select-industry.component.html',
    styleUrls: ['./select-industry.component.scss'],
    animations: [
        trigger('dotAnim', [
            state('inactive', style({
                transform: 'scale(1)',
                opacity: 0.5
            })),
            state('active', style({
                transform: 'scale(1.2)',
                opacity: 1
            })),
            transition('inactive => active', [
                animate('300ms ease-out')
            ]),
            transition('active => inactive', [
                animate('200ms ease-in')
            ])
        ])
    ],
    standalone: false
})
export class SelectIndustryComponent implements OnInit {
 
  industries = [
    {
    key: 'evchargers',
    label: 'EV Chargers',
    desc: 'Charging stations, DC fast chargers, etc.',
    icon: 'assets/svg/industry/Industry-EVCharging.svg',
    previewImg: 'assets/svg/industry/Industries-EVCharger.svg'
  },
  {
    key: 'evfleet',
    label: 'EV Fleet',
    desc: 'Vehicles, batteries, telematics, etc.',
    icon: 'assets/svg/industry/Industry-EVFleet.svg',
    previewImg: 'assets/svg/industry/Industries-EVFleet.svg'
  },
  {
    key: 'retail',
    label: 'EV Chargers',
    desc: 'Charging stations, DC fast chargers, etc.',
    icon: 'assets/svg/industry/Industry-EVCharging.svg',
    previewImg: 'assets/svg/industry/Industries-EVCharger.svg'
  },
  {
    key: 'transportation',
    label: 'EV Fleet',
    desc: 'Vehicles, batteries, telematics, etc.',
    icon: 'assets/svg/industry/Industry-EVFleet.svg',
    previewImg: 'assets/svg/industry/Industries-EVFleet.svg'
  },
  {
    key: 'f_and_b',
    label: 'Food and Beverage',
    desc: 'Coffee machines, refrigerators, etc.',
    icon: 'assets/svg/industry/Industry-FnB.svg',
    previewImg: 'assets/svg/industry/Industries-FnB.svg'
  },
  {
    key: 'hvac',
    label: 'HVAC',
    desc: 'Air conditioners, chillers, etc.',
    icon: 'assets/svg/industry/Industry-HVAC.svg',
    previewImg: 'assets/svg/industry/Industries-HVAC.svg'
  },
  {
    key: 'manufacturing',
    label: 'Manufacturing',
    desc: 'Conveyor belts, robotic arms, etc.',
    icon: 'assets/svg/industry/Industry-Manufacturing.svg',
    previewImg: 'assets/svg/industry/Industries-Manufacturing.svg'
  },
  {
    key: 'medical',
    label: 'Medical',
    desc: 'Diagnostic equipment, beds, etc.',
    icon: 'assets/svg/industry/Industry-Medical.svg',
    previewImg: 'assets/svg/industry/Industries-Medical.svg'
  },
  {
    key: 'construction',
    label: 'Construction',
    desc: 'Generators, cranes, etc.',
    icon: 'assets/svg/industry/Industry-Construction.svg',
    previewImg: 'assets/svg/industry/Industries-Construction.svg'
  },
  {
    key: 'default',
    label: 'General Services',
    desc: 'Facility equipment, etc.',
    icon: 'assets/svg/industry/Industry-GeneralService.svg',
    previewImg: 'assets/svg/industry/Industries-General.svg'
  }
  // {
  //   key: 'retail',
  //   label: 'Retail',
  //   desc: 'Checkout sys, security cameras, etc.',
  //   icon: 'assets/svg/industry/Industry-Retail.svg',
  //   previewImg: 'assets/svg/industry/Industries-Retail.svg'
  // },
  // {
  //   key: 'transportation',
  //   label: 'Transportation',
  //   desc: 'Fleet, forklifts, EV chargers, etc.',
  //   icon: 'assets/svg/industry/Industry-Transportation.svg',
  //   previewImg: 'assets/svg/industry/Industries-Transportation.svg'
  // },
  // {
  //   key: 'agriculture',
  //   label: 'Agriculture',
  //   desc: 'Tractors, sprayers, feeding systems, etc.',
  //   icon: 'assets/svg/industry/Industry-Agriculture.svg',
  //   previewImg: 'assets/svg/industry/Industries-Agriculture.svg'
  // },
  // ... other industries
];

selectedIndustry: any=null; // default selection
currentStep = 2;
  industryDetail: any = [];
  selectedIndustryData: any;

  constructor(
    private router: Router,  
    private transitionService: OnBoardTransitionService,
    private onboardDataService: OnboardDataService,
    private settingsService : SettingService,
    private spinner:NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private errorUtil: ErrorUtil,
    private auth: AuthenticationService,
    private mixPanelService: MixpanelService) { }

  ngOnInit(): void {
    this.getIndustryDetail();
    const currentKey = this.onboardDataService.getSelectedIndustry();
    if (currentKey) {
      this.selectedIndustry = currentKey;
    }

    this.onboardDataService.selectedIndustry$.subscribe(key => {
      this.selectedIndustry = key;
    });
  }
  get selectedPreview(): string {
    return this.industryDetail.find(i => i.key === this.selectedIndustry)?.previewImg || '';
  }
/****************************************** Get Industry Detail *****************************/
  getIndustryDetail(){
    
        this.spinner.show();
        this.settingsService.getIndustrySettings().subscribe((response:any) => {
           this.industryDetail = response; // Assuming response is an array of industry details

           var setupIndustry =  JSON.parse(localStorage.getItem('selectedIndustry'))
           this.selectedIndustryData =setupIndustry ?  setupIndustry:this.industryDetail[0];
          // Remove any industry with csvPrefix === 'coffee'
          this.industryDetail = this.industryDetail.filter((item: any) => item.csvPrefix !== 'coffee');

          this.selectedIndustry = setupIndustry ? setupIndustry.csvPrefix : this.industryDetail[0]?.key; // Set default selected industry key
           console.log('Industry Detail:', this.selectedIndustryData,"-- selected industry --",this.selectedIndustry);
           if(this.industryDetail.length > 0){
             this.industryDetail.forEach((element: any) => {
            const match = this.industries.find(ind => ind.key === element.csvPrefix);

            if (match) {
                // If a match is found, update the element with the matched data
                element.key = element.csvPrefix,
                element.label= match.label,
                element.desc= match.desc,
                element.icon= match.icon,
                element.previewImg= match.previewImg
            }else{
              // If no match found, you can handle it here
              console.warn(`No match found for industry key: ${element.csvPrefix}`);
              // Optionally, you can set default values or handle it as needed
                element.key = element.csvPrefix,
                element.label= element.name,
                element.desc= '',
                element.icon= 'assets/svg/industry/Industry-GeneralService.svg',
                element.previewImg= 'assets/svg/industry/Industries-General.svg';
            }
          });
           } else {
            this.industryDetail = this.industries; // Fallback to default industries if no data is returned
            this.selectedIndustry = this.industries[0].key;
            this.onboardDataService.setIndustrySelection(this.selectedIndustry)
           }
            this.spinner.hide();
          
        })
      
  }

  selectIndustry(industry: any) {
    console.log('Selected Industry:', industry.key);
  // Update the selected industry and trigger any necessary actions
    this.selectedIndustryData = industry
    this.selectedIndustry = industry.key;
    this.onboardDataService.setIndustrySelection(industry.key);
     this.cdRef.detectChanges();
  }
  
  goToPrevious() {
    this.transitionService.startTransition('company-setup');
  }

goToNext() {
  if(!this.selectedIndustry) {
     this.errorUtil.setErrorMessage(400, null ,  'Please select an industry to proceed', 'error',3000);
    return;
  }
  localStorage.setItem('selectedIndustry', JSON.stringify(this.selectedIndustryData));
  this.getAnalyticsBrowser();
    this.transitionService.startTransition('customize-workspace');
  }
getAnalyticsBrowser() {
  //Mixpanel Event Tracking
  if(localStorage.getItem('packageCode') != null && localStorage.getItem('packageCode') != 'Old'){
    this.mixPanelService.track('w_onboard_setindustry', { propertyName: 'w_onboard_setindustry', method: 'button_click'});
  }
}
}
